var React = require("react");

function Button(props) {
	if (!props.display) {
		return null;
	}
	var icon = null;
	if (props.icon !== "") {
		icon = (
			<i className={props.icon} aria-hidden="true"></i>
		);
	}
	var error = null;
	if (props.error) {
		error = (
			<div className="btn_error alert-danger">
				<div>
					<p>
						<i className="fa fa-exclamation-circle"></i>
						{props.error}
					</p>
				</div>
			</div>
		);
	}
	return (
		<span>
			{error}
			<button
				type="button"
				className={"btn " + props.style}
				onClick={props.onClick}
				disabled={props.disabled}
			>
				{icon}
				{props.value}
			</button>
		</span>
	);
}

Button.defaultProps = {
	display: true,
	style: "btn-primary",
	disabled: false,
	value: "button",
	icon: ""
};

module.exports = Button;
